import { createInstance, logBi } from '../bi';

export default () => {
  // create BI instance before rendering application
  createInstance();

  logBi('widget.embed.loaded', {
    videoWidth: window.innerWidth,
    videoHeight: window.innerHeight,
  });
};
